import "./mainLayout.css";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";
import { NavLink } from "react-router-dom";

const MainLayout = ({ children, breadcrumbData = "" }) => {
  const routes = [
    { path: "/", breadcrumb: "Admin" },

    {
      path: "/invoice-verification/ai-verified-invoices",
      breadcrumb: " / invoice verification / ai verified invoices",
    },
    {
      path: "/invoice-verification/ai-verified-invoices/view/:id",
      breadcrumb: breadcrumbData,
    },
    {
      path: "/invoice-verification/verified-invoices",
      breadcrumb: " / invoice verification / verified invoices",
    },
    {
      path: "/invoice-verification/verified-invoices/view/:id",
      breadcrumb: breadcrumbData,
    },
    {
      path: "/invoice-verification/ai-flagged-invoices",
      breadcrumb: " / invoice verification / ai flagged invoices",
    },
    {
      path: "/invoice-verification/ai-flagged-invoices/view/:id",
      breadcrumb: breadcrumbData,
    },
    {
      path: "/invoice-verification/pending-invoices",
      breadcrumb: " / invoice verification / pending invoices",
    },
    {
      path: "/invoice-verification/pending-invoices/view/:id",
      breadcrumb: breadcrumbData,
    },
    {
      path: "/invoice-verification/rejected-invoices",
      breadcrumb: " / invoice verification / rejected invoices",
    },
    {
      path: "/invoice-verification/rejected-invoices/view/:id",
      breadcrumb: breadcrumbData,
    },
  ];

  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  return (
    <>
      <div className="w-100 main-sub-container">
        <div className="main-page">
          <div className="container-main-div">
            <div className="mx-lg-4">
              {breadcrumbs.map(({ match, breadcrumb }) => (
                <NavLink
                  key={match.pathname}
                  to={match.pathname}
                  className="header-route-page fw_400 cursor_pointer"
                >
                  <span className="fs_18">{breadcrumb}</span>
                </NavLink>
              ))}
            </div>

            <div className="main-list-container my-2 py-1 d-flex justify-content-between flex-column">
              <main className="d-flex flex-column w-100 main-container">
                {children}
              </main>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MainLayout;
